import { isValidNumber } from '../isValidNumber';
var isLeftMoreOrEqualThanRight = function isLeftMoreOrEqualThanRight(a, b) {
  return a >= b;
};
var isLeftMoreThanRight = function isLeftMoreThanRight(a, b) {
  return a > b;
};

/**
 * Утилита проверяет, находится ли number в диапазоне
 * учитываются граничные значения: includeFrom, includeTo
 * */
export var isNumInRange = function isNumInRange(value, options) {
  var includeFrom = options.includeFrom,
    includeTo = options.includeTo,
    to = options.to,
    from = options.from;
  var checkLeft = includeFrom ? isLeftMoreOrEqualThanRight : isLeftMoreThanRight;
  var checkRight = includeTo ? isLeftMoreOrEqualThanRight : isLeftMoreThanRight;
  return (!isValidNumber(from) || checkLeft(value, from)) && (!isValidNumber(to) || checkRight(to, value));
};